/**
 * @author Alex w
 * @description Check the description accordion. If the description content it long, it shows "show more" button
 */

const descriptionContent = document.querySelector(
  ".description .panel-body__content"
);
const descriptionPanel = document.querySelector(".description .panel-body");

const $panelBody = $(".description .panel-body");
const prevCss = $panelBody.attr("style");
$panelBody.css({
  position: "absolute",
  visibility: "hidden",
  display: "block",
});
const height = $panelBody.height();
$panelBody.attr("style", prevCss ? prevCss : "");

if (height > 800) {
  $panelBody.addClass("panel-body--long-content");
  $panelBody.addClass("panel-body--show-more");
}

const showMoreButton = document.querySelector(".panel-body__load-more");
showMoreButton.addEventListener("click", function () {
  $panelBody.toggleClass("panel-body--long-content");
  if (showMoreButton.textContent == "Show Less") {
    $("html, body").animate(
      {
        scrollTop: window.innerWidth > 768 ? 500 : 1700,
      },
      1000
    );
  }
  showMoreButton.textContent =
    showMoreButton.textContent == "Show More" ? "Show Less" : "Show More";
});

// Check recharge legacy widget
let intervalCheck = 0;
const rechargeInterval = setInterval(() => {
  const rechargeWidget = document.querySelector(".rc-container-wrapper");
  if (rechargeWidget) {
    clearInterval(rechargeInterval);
    const rechargeWrapper = document.querySelector(".rc-widget-injection-parent");
    if (rechargeWrapper.children.length == 0) {
      $(".rc-container-wrapper").appendTo(".rc-widget-injection-parent");
    }
  }

  if (++intervalCheck == 200) {
    clearInterval(rechargeInterval);
  }
}, 100);
